import React from 'react';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import FaIcon from '../FaIcon';
import urlHelper from '../../Helpers/urlHelper';
import PlaceHolderField from './BaseInputs/PlaceHolderField';
import { TYPES_WITHOUT_ERASER, TYPES_WITHOUT_LABEL, TYPES_RENDERED_WITHOUT_CHROME } from './inputTypeGroups';

export default class InputWithClearBase extends React.Component {
  static defaultProps = {
    className: 'w-100 form-control form-control-sm',
    disableClearButton: false,
    disabled: false,
    displayHyperlink: false,
    errorMessage: '',
    fieldName: 'defaultFieldname',
    info: '',
    isInOneRow: false,
    labelIsDisabled: false,
    labelText: 'Default Label Text',
    margin: 'm-1',
    onChange: () => {},
    renderedInputField: null,
    tooltipText: null,
    type: InputTypesEnum.Text,
    value: null,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  defaultValue() {
    switch (this.props.type) {
      case InputTypesEnum.Date:
        return dateTimeHelper.toYYYYsMMsDD(new Date(), '-');
      case InputTypesEnum.DateWithIndefinite:
        return dateTimeHelper.indefiniteDateValue();
      case InputTypesEnum.PhoneNumber:
      case InputTypesEnum.BusinessPhone:
        return '+1-';
      default:
        return '';
    }
  }

  renderPlaceHolderField() {
    return (
      <PlaceHolderField
        className={this.props.className}
        fieldName={this.props.fieldName}
      />
    );
  }

  renderInfoTooltip() {
    return this.props.tooltipText ? (
      <>
        &nbsp;
        <FaIcon
          iconName='fa-solid fa-circle-info'
          tooltipText={this.props.tooltipText}
        />
      </>
    ) : null;
  }

  renderEraser() {
    // Fields that never get an eraser render nothing (unchanged layout).
    const neverEraser =
      this.props.disabled || this.props.disableClearButton || TYPES_WITHOUT_ERASER.includes(this.props.type);
    if (neverEraser) {
      return null;
    }

    // For eraser-eligible fields the button is always rendered so its space is reserved: when the
    // value is at its default (e.g. an empty select / "none") the button is shown disabled but keeps
    // its footprint, so the field width stays constant instead of shifting when the value is cleared.
    // DateWithIndefinite defaults to the indefinite sentinel (a Date), so compare by
    // "is it indefinite" — strict equality never matches a freshly created Date.
    const atDefault =
      this.props.type === InputTypesEnum.DateWithIndefinite
        ? dateTimeHelper.isIndefinite(this.props.value)
        : this.props.value === this.defaultValue();
    return (
      <span
        className={`btn btn-info btn-sm form-control-orange ${atDefault ? 'disabled' : ''}`}
        aria-disabled={atDefault}
        onClick={atDefault ? undefined : () => this.props.onChange(this.props.fieldName, this.defaultValue())}
      >
        <i className='fa-solid fa-eraser' />
      </span>
    );
  }

  renderRedirectLinkTag(errorMessage) {
    const disabled = !this.props.displayHyperlink || errorMessage;
    const url = urlHelper.generateRedirectUrlWithMultipleParameters('sales', [
      { key: 'CompanyName', value: this.props.value },
      { key: 'UserId', value: '' },
      { key: 'IsActive', value: '' },
    ]);

    return !disabled ? (
      <div className={'text-left p-1 text-danger'}>
        <a
          style={{ color: 'yellow' }}
          href={url}
          target={'_blank'}
        >
          <i className='fa-solid fa-magnifying-glass-arrow-right' /> Open new tab to display matching leads
        </a>
      </div>
    ) : null;
  }

  renderErrorMessage(errorMessage) {
    return errorMessage || this.props.info ? (
      <div className={`text-left p-1 ${errorMessage ? 'text-danger' : 'text-light'}`}>
        {errorMessage ? errorMessage : this.props.info ? this.props.info : ''}
      </div>
    ) : null;
  }

  renderLabel(errorMessage) {
    const disabled = this.props.labelIsDisabled || TYPES_WITHOUT_LABEL.includes(this.props.type);

    return !disabled ? (
      <label
        className={`m-0 p-0 defaultfontsize ${errorMessage === '' && this.props.info !== '' ? 'text-light' : ''}`}
        htmlFor={`htmlidfor${this.props.fieldName}`}
      >
        {this.props.labelText}
        {this.renderInfoTooltip()}
      </label>
    ) : null;
  }

  // The input together with its clear button, or a placeholder when the field is disabled.
  renderFieldOrPlaceholder() {
    return !this.props.disabled ? (
      <>
        {this.props.renderedInputField}
        {this.renderEraser()}
      </>
    ) : (
      this.renderPlaceHolderField()
    );
  }

  render() {
    if (TYPES_RENDERED_WITHOUT_CHROME.includes(this.props.type)) {
      return this.props.renderedInputField;
    }

    return (
      <div
        className={
          'iwc-field col text-center rounded arial m-1 p-1' +
          (this.props.labelText && this.props.type !== InputTypesEnum.EmptySpace ? ' hover' : '') +
          (this.props.errorMessage
            ? ' border rounded border-danger bg-warning m-1 '
            : this.props.info !== '' || this.props.errorMessage !== ''
            ? 'border bg-secondary '
            : '')
        }
        key={`k${this.props.fieldName}`}
      >
        {this.props.isInOneRow ? (
          <div className={`container-fluid ${this.props.margin}`}>
            <div className='row'>
              {!this.props.labelIsDisabled && (
                <div className='col-3 wizzarddiv'>
                  {this.props.labelText}
                  {this.renderInfoTooltip()}
                </div>
              )}
              <div className='col-9'>
                <div className={'d-flex '}>{this.renderFieldOrPlaceholder()}</div>
              </div>
            </div>
            {this.renderErrorMessage(this.props.errorMessage)}
            {this.renderRedirectLinkTag(this.props.errorMessage)}
          </div>
        ) : (
          <div>
            {this.renderLabel()}
            <div className={`d-flex ${this.props.margin}`}>{this.renderFieldOrPlaceholder()}</div>
            {this.renderErrorMessage(this.props.errorMessage)}
          </div>
        )}
      </div>
    );
  }
}
